function getConfig(name, defaultValue=null) {
	// If inside a docker container, use window.ENV
	if (window.ENV !== undefined) return window.ENV[name] || defaultValue;
	return process.env[name] || defaultValue;
};

export function getAppVersion() {
	return getConfig("REACT_APP_VERSION", "-");
};

export function getBackendUrl() {
  return getConfig("REACT_APP_BACKEND_URL");
};
